exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".box[data-v-91d4683e]{margin:10px;padding:20px;border:1px solid rgba(0,0,0,.1);border-radius:4px}.container-telas[data-v-91d4683e]{overflow-x:scroll}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/styleguide/telas.vue"],"names":[],"mappings":"AACA,sBACE,YAAa,AACb,aAAc,AACd,gCAAqC,AACrC,iBAAmB,CACpB,AACD,kCACE,iBAAmB,CACpB","file":"telas.vue","sourcesContent":["\n.box[data-v-91d4683e] {\n  margin: 10px;\n  padding: 20px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n}\n.container-telas[data-v-91d4683e] {\n  overflow-x: scroll;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-91d4683e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/styleguide/telas.vue
// module id = 1258
// module chunks = 3